const Footer = () => {
  return (
    <>
      <footer>
        <p>
          <a href="https://iamrishavraj1.netlify.app/">
            Developed by Rishav Raj 🧡
          </a>
        </p>
      </footer>
    </>
  );
};

export default Footer;
